import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Compatibility redirects
  { path: '', redirectTo: 'overview/artists', pathMatch: 'full' },
  { path: 'artists', redirectTo: 'overview/artists', pathMatch: 'full' },
  { path: 'labels', redirectTo: 'overview/labels', pathMatch: 'full' },
  { path: 'brands', redirectTo: 'overview/brands', pathMatch: 'full' },
  { path: 'songs', redirectTo: 'charts/ifpi', pathMatch: 'full' },
  { path: 'socials', redirectTo: 'charts/socials', pathMatch: 'full' },
  { path: 'radio', redirectTo: 'charts/radio', pathMatch: 'full' },
  {
    path: 'coming-soon',
    loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
    title: 'Coming Soon'
  },

  // Overview Pages
  {
    path: 'overview',
    children: [
      {
        path: 'artists',
        loadComponent: () =>
          import('./pages/overview/artists/artist-rankings.component').then((m) => m.ArtistRankingsComponent),
        title: 'Artists'
      },
      {
        path: 'year',
        loadComponent: () =>
          import('./pages/overview/year/overview-year.component').then((m) => m.OverviewYearComponent),
        title: 'Year in Review'
      },
      {
        path: 'labels',
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
        title: 'Labels'
      },
      {
        path: 'brands',
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
        title: 'Brands'
      },
      { path: '', redirectTo: 'artists', pathMatch: 'full' }
    ]
  },

  // Charts Pages
  {
    path: 'charts',
    children: [
      {
        path: 'ifpi',
        loadComponent: () =>
          import('./pages/charts/ifpi/song-charts.component').then((m) => m.SongChartsComponent),
        title: 'IFPI Chart'
      },
      {
        path: 'billboard',
        loadComponent: () =>
          import('./pages/charts/billboard/billboard-charts.component').then((m) => m.BillboardChartsComponent),
        title: 'Billboard Chart'
      },
      {
        path: 'spotify',
        loadComponent: () =>
          import('./pages/charts/spotify/spotify-charts.component').then((m) => m.SpotifyChartsComponent),
        title: 'Spotify Chart'
      },
      {
        path: 'apple-music',
        loadComponent: () =>
          import('./pages/charts/apple-music/apple-music-charts.component').then((m) => m.AppleMusicChartsComponent),
        title: 'Apple Music Chart'
      },
      {
        path: 'shazam',
        loadComponent: () =>
          import('./pages/charts/shazam/shazam-charts.component').then((m) => m.ShazamChartsComponent),
        title: 'Shazam Chart'
      },
      {
        path: 'socials',
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
        title: 'Socials'
      },
      {
        path: 'radio',
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
        title: 'Radio'
      },
      { path: '', redirectTo: 'ifpi', pathMatch: 'full' }
    ]
  },

  // Other routes
  {
    path: 'artist/:id',
    loadComponent: () =>
      import('./pages/artist-detail/artist-detail.component').then((m) => m.ArtistDetailComponent),
    data: { isDetail: true },
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin-dashboard/admin-dashboard.component').then((m) => m.AdminDashboardComponent),
    canActivate: [adminGuard],
    title: 'Admin',
  },
  {
    path: 'admin/artists/new',
    loadComponent: () =>
      import('./pages/admin-artist-edit/admin-artist-edit.component').then((m) => m.AdminArtistEditComponent),
    canActivate: [adminGuard],
    title: 'New Artist',
  },
  {
    path: 'admin/artists/:id/edit',
    loadComponent: () =>
      import('./pages/admin-artist-edit/admin-artist-edit.component').then((m) => m.AdminArtistEditComponent),
    canActivate: [adminGuard],
    title: 'Edit Artist',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard],
    title: 'Dashboard',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    title: 'Login',
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.component').then((m) => m.RegisterComponent),
    title: 'Register',
  },
  {
    path: 'label/:slug',
    loadComponent: () =>
      import('./pages/label-detail/label-detail.component').then((m) => m.LabelDetailComponent),
    data: { isDetail: true },
  },
  {
    path: 'compare',
    loadComponent: () => import('./pages/compare/compare.component').then((m) => m.CompareComponent),
    title: 'Compare Artists',
  },
  {
    path: '**',
    redirectTo: 'overview/artists',
  },
];
